import { useState, useEffect } from "react";
import api from "../../../utils/api";
import { formatDateForAPI } from "../utils/orderUtils";
import { useRestaurantConfig } from "../../../utils/restaurantConfig";
import { dateFromYmd, getRestaurantTodayDate } from "../../../utils/dateTimeUtils";

export const useCustomerReport = () => {
  const { timezone } = useRestaurantConfig();
  const today = dateFromYmd(getRestaurantTodayDate(timezone));

  const [customers, setCustomers] = useState([]);
  const [totalCustomers, setTotalCustomers] = useState(0);
  const [totalOrders, setTotalOrders] = useState(0);
  const [totalSales, setTotalSales] = useState(0);
  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const [showAllDates, setShowAllDates] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchCustomerReport = async () => {
      setIsLoading(true);
      try {
        let endpoint = "/orders/customer-report";

        if (!showAllDates && fromDate && toDate) {
          endpoint = `/orders/customer-report?startDate=${formatDateForAPI(
            fromDate,
          )}&endDate=${formatDateForAPI(toDate)}`;
        }

        const res = await api.get(endpoint);
        setCustomers(res.data?.customers || []);
        setTotalCustomers(res.data?.totalCustomers || 0);
        setTotalOrders(res.data?.totalOrders || 0);
        setTotalSales(res.data?.totalSales || 0);
      } catch (err) {
        console.error("Fetch customer report error:", err);
        setCustomers([]);
        setTotalCustomers(0);
        setTotalOrders(0);
        setTotalSales(0);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCustomerReport();
  }, [fromDate, toDate, showAllDates]);

  return {
    customers,
    totalCustomers,
    totalOrders,
    totalSales,
    fromDate,
    setFromDate,
    toDate,
    setToDate,
    showAllDates,
    setShowAllDates,
    isLoading,
  };
};
